import { Component, Input, OnInit } from '@angular/core';
import _ from 'lodash';
import moment from 'moment';
import { HelperService } from './../../../../../_shared/services/helper.service';

@Component({
    selector: 'covid-form',
    templateUrl: './covid-form.component.html',
    styles: [],
})
export class CovidFormComponent implements OnInit {
    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public surveyData: any;
    @Input()
    public surveyType: '14day' | '1day' | '0day' | 'new';
    @Input()
    public readOnly = false;
    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public additionalData: any;

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public timeInputMask: any = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public calendarOptions: any;
    public inputHours: string;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public inputDate: any;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public pctDate: any;

    constructor(private helper: HelperService) {}

    ngOnInit() {
        this.calendarOptions = this.helper.getDateSettngs(moment(this.surveyData.callDate));
        this.inputDate = this.surveyData.date ? moment(this.surveyData.callDate).format('DD.MM.YYYY') : moment().format('DD.MM.YYYY');

        this.pctDate = this.surveyData?.form?.pctDate ? moment(this.surveyData?.form?.pctDate).format('DD.MM.YYYY') : moment().format('DD.MM.YYYY');

        this.inputHours = this.surveyData.date ? moment(this.surveyData.callDate).subtract(2, 'hour').format('HH:mm') : moment().format('HH:mm');
        if (_.isNil(this.surveyData.form.investigationType)) {
            this.surveyData.form.investigationType = _.get(this.additionalData, 'service.name');
        }
        if (!_.get(this.surveyData, 'date')) {
            //ni shranjeno
            this.surveyData.callDate = moment();
        }

        if (Object.keys(this.surveyData.form).length <= 1) {
            this.setDefaultFormData(this.surveyData.form.investigationType);
        }
    }

    public setDefaultFormData(investigationType?) {
        //nov objekt --> brez conjunctivitis in feelingSick
        this.surveyData.form = {
            cold: false,
            contactWithPositive: false,
            contactWithPotentialPositive: false,
            cough: false,
            diarrhea: false,
            family: false,
            heavyBreathing: false,
            muscleAche: false,
            positiveTest: false,
            taste: false,
            throat: false,
            tt: false,
            investigationType: investigationType,
        };
        if (this.surveyType === 'new') {
            this.surveyData.form.pctType = 'Cepljen/a';
            this.surveyData.form.pctDate = moment();
            this.surveyData.form.pctResult = false;
        }
    }

    public setDate(event, type: 'timeOfPct' | 'timeOfTerm'): void {
        //spremeniš uro v inputu
        let hours;
        let minutes;
        if (type === 'timeOfTerm') {
            this.surveyData.callDate = moment(event.start);
            if (this.inputHours.length == 5 || (this.inputHours.length == 4 && !this.inputHours.includes(':'))) {
                if (this.inputHours.includes(':')) {
                    hours = this.inputHours.split(':')[0];
                    minutes = this.inputHours.split(':')[1];
                } else {
                    hours = this.inputHours.substring(0, 2);
                    minutes = this.inputHours.substring(2);
                }
                this.surveyData.callDate = moment(this.surveyData.callDate).set({
                    hours: Number(hours),
                    minute: Number(minutes),
                });
            }
        } else if (type === 'timeOfPct') {
            this.surveyData.form.pctDate = moment(event.start);
        }
    }
    public setHour(event) {
        //ko spremeniš datum na koledarj inputu
        if (event.target.value.length == 5) {
            const hours = event.target.value.split(':')[0];
            const minutes = event.target.value.split(':')[1];
            this.surveyData.callDate = moment(this.surveyData.callDate).set({
                hour: hours,
                minute: minutes,
            });
        }
    }
}
